import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';

@Directive({
    selector: '[appImageFallback]',
    standalone: false
})
export class ImageFallbackDirective implements OnInit {
  @Input() sportOne?: number;
  @Input() sportTwo?: number;
  @Input() fallbackUrl: string = '';

  private sportImageMap: Record<number, string> = {
    1: 'ADVENTURE_RACING.webp',
    2: 'AQUATHLON.webp',
    3: 'BASKETBALL.webp',
    7: 'CROSS_COUNTRY_SKIING.webp',
    8: 'cross-running.webp',
    9: 'CROSSFIT.webp',
    10: 'CYCLING_CYCLOCROSS.webp',
    11: 'CYCLING_ENDURO.webp',
    12: 'CYCLING_GRAVEL.webp',
    13: 'cycling-mountainbike.webp',
    14: 'CYCLING_PUMP_TRACK.webp',
    15: 'CYCLING_ROAD.webp',
    16: 'DUATHLON.webp',
    17: 'ENDURO_AUTO_RACING.webp',
    18: 'ENDURO_CROSS_COUNTRY.webp',
    19: 'FITNESS.webp',
    20: 'FOOTBALL.webp',
    21: 'HANDBALL.webp',
    22: 'hiking.webp',
    23: 'kayak.webp',
    24: 'MOTOCROSS.webp',
    26: 'nordic-walking.webp',
    30: 'road-running.webp',
    32: 'rowing.webp',
    33: 'skiing.webp',
    34: 'sup.webp',
    36: 'trail-running.webp',
    37: 'triathlon.webp',
    38: 'velodrome.webp',
    39: 'volleyball.webp',
    40: 'walking.webp',
    // Default case
    0: 'default.webp'
  };

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const fallback =
      this.sportImageMap[this.sportOne!] ||
      this.sportImageMap[this.sportTwo!] ||
      this.sportImageMap[0]; // Default fallback

    // TODO
    // const fullFallbackUrl = `${environment.assetsImagesPath}/assets/img/image-sport-fallbacks/${fallback}`;
    const fullFallbackUrl = `/assets/img/image-sport-fallbacks/${fallback}`;

    this.fallbackUrl = this.fallbackUrl || fullFallbackUrl;

    this.renderer.listen(this.el.nativeElement, 'error', () => {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.fallbackUrl);
    });
  }
}
